<template>
  <div class="Reports__View">
    <EntityListLayout v-if="tabs.length" :tabs="tabs" ref="entity" @onNewEntitySave="onNewEntitySave">
      <template #title>ניהול מסלולים בקורס {{ course.name }}</template>
      <template #button>
        <a @click="addLecturesLearningTrack" class="link-button">
          הוספת מסלול
        </a>
      </template>
      <template v-slot:counter="slotProps">
        סה"כ <b>{{ getTotalRecords(slotProps) }} </b>
      </template>
    </EntityListLayout>
  </div>
</template>
<script>
import CoursesService from "@/services/CoursesService";
import EntityListLayout from "@/components/EntityListLayout.vue";
import LecturesLearningTrackEntity from "@/views/LecturesLearningTrackEntity.vue";
import DialogAddLecturesLearningTrack from '@/components/DialogAddLecturesLearningTrack.vue';
import {
  ModalProgrammatic as Modal,
} from 'buefy';
import FieldService from "@/services/FieldService";

export default {
  name: "Reports",
  data() {
    return {
      tabs: [],
    };
  },
  components: {
    EntityListLayout,
  },
  computed: {
    course() {
      return this.$store.state.auth.course;
    },
  },
  created() {
    this.create();
  },
  methods: {
    create() {
      const lessonsFields = FieldService.list("lecturesLearningTracks");

      const sideViewEntity = {
        component: LecturesLearningTrackEntity,
        preview: true,
        readOnly: !this.isAdmin,
        title: "פרטי מסלול",
        recordUrl: "books",
        recordTitle: "הצג ספר",
        hideRecord: true
      };
      const fields = [
        { ...lessonsFields.Id, checked: true },
        { ...lessonsFields.Name, checked: true },
        { ...lessonsFields.EditorNote, checked: true },
        { ...lessonsFields.UserNote, checked: true },
        { ...lessonsFields.AvailableFrom, checked: true },
        { ...lessonsFields.AvailableUntil, checked: true },
        { ...lessonsFields.Status, checked: true },
        { ...lessonsFields.SortOrder, checked: true },
      ];

      this.tabs = [
        {
          id: "AllLectureLearningTracks",
          isPrimary: true,
          title: "כל המסלולים",
          getDataAsync: this.getAllLearningTracks,
          perPage: 100,
          fields,
          filters: null,
          sortField: "Id",
          sortOrder: "desc",
          checkableRows: false,
          fastSearch: true,
          fastSearchOptions: {
            propName: "Terms",
            label: "חיפוש מהיר",
          },
          sideViewEntity,
        },
      ];
    },
    addLecturesLearningTrack() {
      Modal.open({
        component: DialogAddLecturesLearningTrack,
        props: {
          store: this.$store
        },
        canCancel: false,
        hasModalCard: true,
        trapFocus: true,
      });
    },
    onNewEntitySave() {
      this.$refs.entity.onNewEntityCancel();
    },
    getAllLearningTracks({ ...rest }) {
      return CoursesService.getCourseLearningTracks(this.course.id, rest).then((r) => ({
        data: {
          TotalResults: r.data.totalResults,
          Items: r.data.items,
        },
      }));
    },
    getTotalRecords(slotProps) {
      return slotProps.tab && slotProps.tab.total && slotProps.tab.total;
    },
  },
};
</script>
<style scoped lang="scss">
.link-button {
  background: #00427e;
  border: none;
  border-radius: 3px;
  padding: 14px 25px;
  color: white;
  cursor: pointer;
}
</style>
